module.exports = "/_next/static/images/d8aeb0222941884ed424d751631b4072-mgm-md-2.png";